import { useRecoilState } from 'recoil';
import { activeMenuAtom } from '../atoms/activeMenu';

export const useActiveMenu = () => {
    const [activeMenu, setActiveMenu] = useRecoilState(activeMenuAtom);

    return { activeMenu, setActiveMenu };
};